import type { DataTableColumn } from '@/components/custom/erp';
import type { LoaiVatTu } from '@/types/schemas';

export const getItemTypeColumns = (handleViewClick: (row: LoaiVatTu) => void): DataTableColumn<LoaiVatTu>[] => [
  {
    field: 'ma_lvt',
    headerName: 'Mã loại vật tư',
    width: 150,
    renderCell: params => (
      <button onClick={() => handleViewClick(params.row)} className='hover:text-blue-500 hover:underline'>
        {String(params.value ?? '')}
      </button>
    )
  },
  { field: 'ten_lvt', headerName: 'Tên loại vật tư', width: 200 }
];
